import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { Flex } from 'antd';
import { FC } from 'react';
import { Task } from '../../../../ types';
import dayjs from 'dayjs';
import Icon from '../../../../ui/Icon';
import { useNavigate } from 'react-router-dom';

const JobCard: FC<Task> = ({ _id, jobIdShort, title, targetDate }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.jobCard} onClick={() => navigate(_id)}>
      <p className={styles.name}>{title}</p>

      <Flex vertical align="end" gap={8}>
        <div className={styles.idChip}>
          #{jobIdShort} <Icon slug="arrow_vertical" />
        </div>

        <Flex align="center" gap={6}>
          <p className={styles.date}>{dayjs(targetDate).format('HH : mm')}</p>
          <p className={styles.separator}>•</p>
          <p className={styles.date}>{dayjs(targetDate).format('DD/MM/YYYY')}</p>
        </Flex>
      </Flex>
    </div>
  );
};

export default observer(JobCard);
